export const calculateHideOrShowAttribute = (
  hideEmptyAttributes: boolean,
  value: any,
  attribute: JSX.Element,
) => {
  if (hideEmptyAttributes) {
    if (value == null) {
      return null;
    }

    if (Array.isArray(value) && value.length === 0) {
      return null;
    }

    if (value === '') {
      return null;
    }
  }

  return attribute;
};
